function createData(um, dois, tres, quatro, cinco, seis) {
  return { um, dois, tres, quatro, cinco, seis };
}

export const cols = [
  [
    createData("6h", "7h", "8h", "9h", "10h", "11h"),
    createData("12h", "13h", "14h", "15h", "16h", "17h"),
  ],
  [
    createData("18h", "19h", "20h", "21h", "22h", "23h"),
    createData("0h", "1h", "2h", "3h", "4h", "5h"),
  ],
];

export const rows = [
  [
    [
      createData(
        { id: "seis-seisquinze", hora: "6h00 às 6h15" },
        { id: "sete-setequinze", hora: "7h00 às 7h15" },
        { id: "oito-oitoquinze", hora: "8h00 às 8h15" },
        { id: "nove-novequinze", hora: "9h00 às 9h15" },
        { id: "dez-dezquinze", hora: "10h00 às 10h15" },
        { id: "onze-onzequinze", hora: "11h00 às 11h15" }
      ),
      createData(
        { id: "seisquinze-seistrinta", hora: "6h15 às 6h30" },
        { id: "setequinze-setetrinta", hora: "7h15 às 7h30" },
        { id: "oitoquinze-oitotrinta", hora: "8h15 às 8h30" },
        { id: "novequinze-novetrinta", hora: "9h15 às 9h30" },
        { id: "dezquinze-deztrinta", hora: "10h15 às 10h30" },
        { id: "onzequinze-onzetrinta", hora: "11h15 às 11h30" }
      ),
      createData(
        { id: "seistrinta-seisquarentaecinco", hora: "6h30 às 6h45" },
        { id: "setetrinta-setequarentaecinco", hora: "7h30 às 7h45" },
        { id: "oitotrinta-oitoquarentaecinco", hora: "8h30 às 8h45" },
        { id: "novetrinta-novequarentaecinco", hora: "9h30 às 9h45" },
        { id: "deztrinta-dezquarentaecinco", hora: "10h30 às 10h45" },
        { id: "onzetrinta-onzequarentaecinco", hora: "11h30 às 11h45" }
      ),
      createData(
        { id: "seisquarentaecinco-seiscinquentaenove", hora: "6h45 às 6h59" },
        { id: "setequarentaecinco-setecinquentaenove", hora: "7h45 às 7h59" },
        { id: "oitoquarentaecinco-oitocinquentaenove", hora: "8h45 às 8h59" },
        { id: "novequarentaecinco-novecinquentaenove", hora: "9h45 às 9h59" },
        { id: "dezquarentaecinco-dezcinquentaenove", hora: "10h45 às 10h59" },
        { id: "onzequarentaecinco-onzecinquentaenove", hora: "11h45 às 11h59" }
      ),
    ],
    [
      createData(
        { id: "doze-dozequinze", hora: "12h00 às 12h15" },
        { id: "treze-trezequinze", hora: "13h00 às 13h15" },
        { id: "quatorze-quatorzequinze", hora: "14h00 às 14h15" },
        { id: "quinze-quinzequinze", hora: "15h00 às 15h15" },
        { id: "dezesseis-dezesseisquinze", hora: "16h00 às 16h15" },
        { id: "dezessete-dezessetequinze", hora: "17h00 às 17h15" }
      ),
      createData(
        { id: "dozequinze-dozetrinta", hora: "12h15 às 12h30" },
        { id: "trezequinze-trezetrinta", hora: "13h15 às 13h30" },
        { id: "quatorzequinze-quatorzetrinta", hora: "14h15 às 14h30" },
        { id: "quinzequinze-quinzetrinta", hora: "15h15 às 15h30" },
        { id: "dezesseisquinze-dezesseistrinta", hora: "16h15 às 16h30" },
        { id: "dezessetequinze-dezessetetrinta", hora: "17h15 às 17h30" }
      ),
      createData(
        { id: "dozetrinta-dozequarentaecinco", hora: "12h30 às 12h45" },
        { id: "trezetrinta-trezequarentaecinco", hora: "13h30 às 13h45" },
        { id: "quatorzetrinta-quatorzequarentaecinco", hora: "14h30 às 14h45" },
        { id: "quinzetrinta-quinzequarentaecinco", hora: "15h30 às 15h45" },
        {
          id: "dezesseistrinta-dezesseisquarentaecinco",
          hora: "16h30 às 16h45",
        },
        {
          id: "dezessetetrinta-dezessetequarentaecinco",
          hora: "17h30 às 17h45",
        }
      ),
      createData(
        { id: "dozequarentaecinco-dozecinquentaenove", hora: "12h45 às 12h59" },
        {
          id: "trezequarentaecinco-trezecinquentaenove",
          hora: "13h45 às 13h59",
        },
        {
          id: "quatorzequarentaecinco-quatorzecinquentaenove",
          hora: "14h45 às 14h59",
        },
        {
          id: "quinzequarentaecinco-quinzecinquentaenove",
          hora: "15h45 às 15h59",
        },
        {
          id: "dezesseisquarentaecinco-dezessesiscinquentaenove",
          hora: "16h45 às 16h59",
        },
        {
          id: "dezessetequarentaecinco-dezessetecinquentaenove",
          hora: "17h45 às 17h59",
        }
      ),
    ],
  ],
  [
    [
      createData(
        { id: "dezoito-dezoitoquinze", hora: "18h00 às 18h15" },
        { id: "dezenove-dezenovequinze", hora: "19h00 às 19h15" },
        { id: "vinte-vintequinze", hora: "20h00 às 20h15" },
        { id: "vinteeuma-vinteeumaquinze", hora: "21h00 às 21h15" },
        { id: "vinteeduas-vinteeduasquinze", hora: "22h00 às 22h15" },
        { id: "vinteetres-vinteetresquinze", hora: "23h00 às 23h15" }
      ),
      createData(
        { id: "dezoitoquinze-dezoitotrinta", hora: "18h15 às 18h30" },
        { id: "dezenovequinze-dezenovetrinta", hora: "19h15 às 19h30" },
        { id: "vintequinze-vintetrinta", hora: "20h15 às 20h30" },
        { id: "vinteeumaquinze-vinteeumatrinta", hora: "21h15 às 21h30" },
        { id: "vinteeduasquinze-vinteeduastrinta", hora: "22h15 às 22h30" },
        { id: "vinteetresquinze-vinteetrestrinta", hora: "23h15 às 23h30" }
      ),
      createData(
        { id: "dezoitotrinta-dezoitoquarentaecinco", hora: "18h30 às 18h45" },
        { id: "dezenovetrinta-dezenovequarentaecinco", hora: "19h30 às 19h45" },
        { id: "vintetrinta-vintequarentaecinco", hora: "20h30 às 20h45" },
        {
          id: "vinteeumatrinta-vinteeumaquarentaecinco",
          hora: "21h30 às 21h45",
        },
        {
          id: "vinteeduastrinta-vinteeduasquarentaecinco",
          hora: "22h30 às 22h45",
        },
        {
          id: "vinteetrestrinta-vinteetresquarentaecinco",
          hora: "23h30 às 23h45",
        }
      ),
      createData(
        {
          id: "dezoitoquarentaecinco-dezoitocinquentaenove",
          hora: "18h45 às 18h59",
        },
        {
          id: "dezenovequarentaecinco-dezenovecinquentaenove",
          hora: "19h45 às 19h59",
        },
        {
          id: "vintequarentaecinco-vintecinquentaenove",
          hora: "20h45 às 20h59",
        },
        {
          id: "vinteeumaquarentaecinco-vinteeumacinquentaenove",
          hora: "21h45 às 21h59",
        },
        {
          id: "vinteeduasquarentaecinco-vinteeduascinquentaenove",
          hora: "22h45 às 22h59",
        },
        {
          id: "vinteetresquarentaecinco-vinteetrescinquentaenove",
          hora: "23h45 às 23h59",
        }
      ),
    ],
    [
      createData(
        { id: "zero-zeroquinze", hora: "00h00 às 00h15" },
        { id: "uma-umaquinze", hora: "01h00 às 01h15" },
        { id: "duas-duasquinze", hora: "02h00 às 02h15" },
        { id: "tres-tresquinze", hora: "03h00 às 03h15" },
        { id: "quatro-quatroquinze", hora: "04h00 às 04h15" },
        { id: "cinco-cincoquinze", hora: "05h00 às 05h15" }
      ),
      createData(
        { id: "zeroquinze-zerotrinta", hora: "00h15 às 00h30" },
        { id: "umaquinze-umatrinta", hora: "01h15 às 01h30" },
        { id: "duasquinze-duastrinta", hora: "02h15 às 02h30" },
        { id: "tresquinze-trestrinta", hora: "03h15 às 03h30" },
        { id: "quatroquinze-quatrotrinta", hora: "04h15 às 04h30" },
        { id: "cincoquinze-cincotrinta", hora: "05h15 às 05h30" }
      ),
      createData(
        {
          id: "zerotrinta-zeroquarentaecinco",
          hora: "00h30 às 00h45",
        },
        { id: "umatrinta-umaquarentaecinco", hora: "01h30 às 01h45" },
        { id: "duastrinta-duasquarentaecinco", hora: "02h30 às 02h45" },
        { id: "trestrinta-tresquarentaecinco", hora: "03h30 às 03h45" },
        { id: "quatrotrinta-quatroquarentaecinco", hora: "04h30 às 04h45" },
        { id: "cincotrinta-cincoquarentaecinco", hora: "05h30 às 05h45" }
      ),
      createData(
        {
          id: "zeroquarentaecinco-zerocinquentaenove",
          hora: "00h45 às 00h59",
        },
        { id: "umaquarentaecinco-umacinquentaenove", hora: "01h45 às 01h59" },
        { id: "duasquarentaecinco-duascinquentaenove", hora: "02h45 às 02h59" },
        { id: "tresquarentaecinco-trescinquentaenove", hora: "03h45 às 03h59" },
        {
          id: "quatroquarentaecinco-quatrocinquentaenove",
          hora: "04h45 às 04h59",
        },
        {
          id: "cincoquarentaecinco-cincocinquentaenove",
          hora: "05h45 às 05h59",
        }
      ),
    ],
  ],
];
